import * as React from 'react'
import { cva } from 'class-variance-authority'
import type { VariantProps } from 'class-variance-authority'
import { cn } from '@/models/app/lib/utils'
import { NavigationMenuLink } from '@/components/ui/navigation-menu'

const appNavbarLinkVariants = cva(
  'block rounded-lg transition-colors duration-300 ease-in-out',
  {
    variants: {
      variant: {
        'default': 'group hover:bg-accent/40 hover:!text-primary focus:bg-accent focus:text-accent-foreground !text-muted-foreground h-9 items-center justify-center !rounded-lg !px-4 !text-xl focus:outline-none disabled:pointer-events-none disabled:opacity-50',
        'menu-item': 'hover:bg-accent/80 hover:!text-primary focus:bg-accent focus:text-accent-foreground !text-muted-foreground space-y-1 p-2 !text-xl leading-none no-underline outline-none select-none font-nav',
        'section-header': 'leading-none font-medium',
        'mobile': 'hover:!text-primary !text-muted-foreground font-nav py-2 text-xl hover:!font-semibold',
        'mobile-section': 'text-muted-foreground hover:text-primary font-nav py-1 pl-4 !text-xl',
      },
    },
    defaultVariants: {
      variant: 'menu-item',
    },
  },
)

export interface AppNavbarLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
  VariantProps<typeof appNavbarLinkVariants> {
  asChild?: boolean
}

const AppNavbarLink = React.forwardRef<
  HTMLAnchorElement,
  AppNavbarLinkProps
>(({ className, variant, asChild = false, children, ...props }, ref) => {
  const linkClass = cn(appNavbarLinkVariants({ variant }), className)

  if (asChild) {
    return (
      <NavigationMenuLink asChild>
        <a ref={ref} className={linkClass} {...props}>
          {children}
        </a>
      </NavigationMenuLink>
    )
  }

  return (
    <a ref={ref} className={linkClass} {...props}>
      {children}
    </a>
  )
})

AppNavbarLink.displayName = 'AppNavbarLink'

export default AppNavbarLink
